import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-void text-white flex flex-col">
      <div className="px-6 md:px-12 py-8">
        <Link to="/" className="font-display font-black text-xl tracking-tighter">YEG SCOOT<span className="text-signal">.</span></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md">
          <p className="text-signal font-mono text-xs uppercase tracking-[0.3em] mb-4">Staff only</p>
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-10">Admin Login</h1>

          {error && (
            <div data-testid="login-error" className="border border-destructive/50 bg-destructive/10 text-red-300 px-4 py-3 mb-6 text-sm">
              {error}
            </div>
          )}

          <div className="space-y-5">
            <div>
              <Label className="font-mono text-xs uppercase tracking-widest text-white/60">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="admin-email"
                className="rounded-none mt-2 bg-transparent border-white/20 text-white focus-visible:ring-signal" />
            </div>
            <div>
              <Label className="font-mono text-xs uppercase tracking-widest text-white/60">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="admin-password"
                className="rounded-none mt-2 bg-transparent border-white/20 text-white focus-visible:ring-signal" />
            </div>
          </div>

          <button type="submit" disabled={loading} data-testid="admin-login-button"
            className="w-full bg-signal text-white mt-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-void transition-colors duration-200 disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign in"}
          </button>
          <Link to="/" className="block text-center text-white/40 font-mono text-xs uppercase tracking-widest mt-6 hover:text-white/70">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
